const clientIdStorageKey = "impacto.live.clientId";
const pendingMutationTtlMs = 15_000;

type LiveRequestOperation = {
  type: string;
};

type LiveEventIdentity = {
  clientMutationId?: string;
};

const pendingMutationIds = new Map<string, number>();

export function getLiveRequestHeaders(operation: LiveRequestOperation): Record<string, string> {
  const headers: Record<string, string> = {
    "x-impacto-client-id": getLiveClientId(),
  };

  if (operation.type === "mutation") {
    const clientMutationId = crypto.randomUUID();
    registerPendingMutation(clientMutationId);
    headers["x-impacto-client-mutation-id"] = clientMutationId;
  }

  return headers;
}

export function shouldDeliverLiveEvent(event: LiveEventIdentity): boolean {
  pruneExpiredPendingMutations();

  if (event.clientMutationId && pendingMutationIds.has(event.clientMutationId)) {
    return false;
  }

  return true;
}

function registerPendingMutation(clientMutationId: string) {
  pendingMutationIds.set(clientMutationId, Date.now() + pendingMutationTtlMs);
}

function pruneExpiredPendingMutations() {
  const now = Date.now();
  for (const [clientMutationId, expiresAt] of pendingMutationIds) {
    if (expiresAt <= now) {
      pendingMutationIds.delete(clientMutationId);
    }
  }
}

function getLiveClientId() {
  const storedClientId = window.sessionStorage.getItem(clientIdStorageKey);
  if (storedClientId) {
    return storedClientId;
  }

  const clientId = crypto.randomUUID();
  window.sessionStorage.setItem(clientIdStorageKey, clientId);
  return clientId;
}
